// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum EventTriggerType {
	Unknown = 0,
	DetectionZoneChange = 1,
	DetectionZoneDwell = 2,
	DetectionZoneEntry = 3,
	DetectionZoneExit = 4,
	DetectionZonePresence = 5,
	ScreenLineChange = 6,
	ScreenLineInbound = 7,
	ScreenLineOutbound = 8,
	SpeedingEvent = 9,
	TargetDetected = 10,
	WrongWayEvent = 11,
	NearMissEvent = 12,
	ImpendingZoneEntry = 13,
	LaneLineEvent = 14,
}

export const EventTriggerTypeDisplayNames: { [key in keyof typeof EventTriggerType]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"DetectionZoneChange": "Detection Zone Change",
	1 : "Detection Zone Change",
	"DetectionZoneDwell": "Detection Zone Dwell",
	2 : "Detection Zone Dwell",
	"DetectionZoneEntry": "Detection Zone Entry",
	3 : "Detection Zone Entry",
	"DetectionZoneExit": "Detection Zone Exit",
	4 : "Detection Zone Exit",
	"DetectionZonePresence": "Detection Zone Presence",
	5 : "Detection Zone Presence",
	"ScreenLineChange": "Screen Line Change",
	6 : "Screen Line Change",
	"ScreenLineInbound": "Screen Line Inbound",
	7 : "Screen Line Inbound",
	"ScreenLineOutbound": "Screen Line Outbound",
	8 : "Screen Line Outbound",
	"SpeedingEvent": "Speeding",
	9 : "Speeding",
	"TargetDetected": "Target Detected",
	10 : "Target Detected",
	"WrongWayEvent": "Wrong Way",
	11 : "Wrong Way",
	"NearMissEvent": "Near Miss",
	12 : "Near Miss",
	"ImpendingZoneEntry": "Impending Zone Entry",
	13 : "Impending Zone Entry",
	"LaneLineEvent": "Lane Line",
	14 : "Lane Line",
}

export const getEventTriggerTypeDisplayName = (key: EventTriggerType | (keyof typeof EventTriggerType & string)) => {
	return EventTriggerTypeDisplayNames[key];
}

export const EventTriggerTypeCloudProcessable: ReadonlySet<EventTriggerType> = new Set([
	EventTriggerType.DetectionZoneChange,
	EventTriggerType.DetectionZoneEntry,
	EventTriggerType.DetectionZoneExit,
	EventTriggerType.ScreenLineChange,
	EventTriggerType.ScreenLineInbound,
	EventTriggerType.ScreenLineOutbound,
	EventTriggerType.SpeedingEvent,
	EventTriggerType.TargetDetected,
]);

